import React from "react";
import Image from "next/image";
import Lottie from "lottie-react";
import { ToolAiGridAreaType } from "@/app/ai/enterprise-search/root";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "../common/CommonTitle";
import aiStarIcon from "@/assets/images/icons/star-ai-icon.svg";

const AiGridArea = ({
  gridAreaInfo,
  ref,
}: {
  ref?: React.Ref<HTMLDivElement | null>;
  gridAreaInfo: ToolAiGridAreaType[];
}) => {
  return (
    <section className="xl:pt-22 container px-4 pt-16 md:pt-24" ref={ref}>
      <div className="mb-6 flex flex-col gap-10 sm:mb-8 md:mb-10 md:gap-28 lg:mb-12 xl:gap-32">
        {gridAreaInfo.map((item, index) => (
          <div
            className={`flex flex-col gap-6 xlg:gap-8 xl:gap-10 ${
              index % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
            } `}
            key={index}
          >
            <div className="flex w-full items-center md:-mt-8">
              <div className="flex flex-col gap-4 xl:gap-6">
                <div className="flex flex-col gap-2 xl:gap-4">
                  <div className="mb-2 inline-flex w-fit rounded-full bg-[#f3f3f3] px-3 py-1 text-sm font-semibold">
                    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                      {item.contextualTag}
                    </span>
                  </div>
                  <CommonTitle
                    as="h3"
                    fontWeightClass="font-semibold"
                    color="#202020"
                    fontSizeClass="text-[20px] lg:text-[22px]"
                  >
                    {item.text}
                  </CommonTitle>
                  <CommonSubtitle>{item.subtext}</CommonSubtitle>
                  {item.stepsData && (
                    <div>
                      <ul className="space-y-3">
                        {item.stepsData?.map((step, stepIndex) => (
                          <li
                            key={`${index}-${stepIndex}`}
                            className="flex items-start gap-3"
                          >
                            <Image
                        src={aiStarIcon}
                        alt="AI feature highlight"
                        width={20}
                        height={20}
                        className="inline-block h-5 w-5"
                      />
                            <span className="text-sm leading-6 text-[#202020] sm:text-base">
                              {step}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="relative h-fit w-full overflow-hidden xl:max-h-[542px]">
              {item.featuredVideoJson ? (
                <div aria-hidden="true">
                    <Lottie
                    animationData={item.featuredVideoJson}
                    alt={`${item.text} - Kroolo AI feature`}
                    className="h-full w-full object-contain"
                    loop
                    autoplay
                  />
                </div>
              ) : (
                <Image
                  src={item.image}
                  alt={`${item.text} - Kroolo AI feature`}
                  className="h-full w-full object-contain"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AiGridArea;
